import { Component, ViewChild } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthorizeService } from 'src/app/_core/access-control/authorize.service';
import { ContactService } from 'src/app/_shared/service/contact.service';
import { AppState } from 'src/app/app.state';
import { BulkFavoriteService } from 'src/app/shared/service/bulk-favorite.service';
import { SubscriptionPlanService } from 'src/app/shared/service/subscription-plan.service';
import constants from 'src/constant.json';

@Component({
  selector: 'app-upload-property-list',
  templateUrl: './upload-property-list.component.html',
  styleUrls: ['./upload-property-list.component.scss'],
})
export class UploadPropertyListComponent {
  isDataLoading: boolean = false;
  constructor(
    private bulkFavoriteService: BulkFavoriteService,
    private authorizeService: AuthorizeService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private contactService: ContactService,
    public appState: AppState,
    private subscriptionService: SubscriptionPlanService,
  ) { }

  dialogRef: any;
  uploadFileObject;
  sampleCsvUrl = constants.S3_FILES.PROPERTY_CSV;
  disableUpload = false;
  fileName = null;
  isCSVFileVisible = true;
  onDestroyNotifier$ = new Subject();
  isAutomatedCampEnabled = false;
  automatedFlag = false;


  @ViewChild('addNewFile', { static: true }) addNewFile: any;
  @ViewChild('file') file;

  csvFileColumns: string[] = [
    'status',
    'name',
    'addressCount',
    'validAddressCount',
    'validEmailCount',
    'createdDate',
    'action',
  ];
  csvRecordColumns: string[] = ['contactStatus', 'addressStatus', 'firstName', 'lastName', 'phone', 'email', 'address'];
  filter: string = 'All';



  openPopUp() {

    if (!this.subscriptionService.checkFeatureValidity(constants.PLAN_BASED_FEATURES.uploadContacts.key)) return;


    if (this.appState?.companyInfoValue?.automatedCampaign?.length) {
      this.automatedFlag = true;
    }

    if (!this.authorizeService.canAct('favoriteEdit')) {
      return false;
    }
    this.dialogRef = this.dialog.open(this.addNewFile);

    this.isAutomatedCampEnabled = false;
  }

  clearData() {
    this.fileName = null;
    this.uploadFileObject = null;
  }

  hideUploadMenu(data) {
    this.isCSVFileVisible = data.isCSVFileVisible;
  }

  onCheckboxChange(event: MatCheckboxChange) {

    this.isAutomatedCampEnabled = event.checked;

  }

  UploadFile(filename) {
    if (this.file.errors && (this.file.errors.pattern || this.file.errors.required)) return;
    this.disableUpload = true;
    this.bulkFavoriteService
      .setAddressCSV(this.uploadFileObject, filename, this.isAutomatedCampEnabled)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(
        (res: any) => {
          if (res && res.data) {
            let params = {
              limit: 10,
              offset: 0,
              orderBy: 'createdDate',
              orderType: 'desc',
            };
            this.contactService
              .getContactFileList()
              .pipe(takeUntil(this.onDestroyNotifier$))
              .subscribe((res) => { });
            this.contactService.checkVerificationStatus(res.data, params);
          }
          this.dialogRef.close();
          this.clearData();
          this.disableUpload = false;
        },
        (err) => {
          if (err && err.error && err.error.message) {
            this.openSnackBar(err.error.message, 'snackbar-warning');
          }
          this.dialogRef.close();
          this.clearData();
          this.disableUpload = false;
        }
      );
  }

  openSnackBar(message, style) {
    if (message) {
      this.snackBar.open(message, '', {
        duration: 3000,
        panelClass: [style ? style : ''],
        verticalPosition: 'top',
      });
    }
  }

  isExcelFile;
  isExcelFileTrue;
  onFileChange(files) {
    this.isExcelFileTrue = '';
    const target: DataTransfer = <DataTransfer>files.target;
    this.isExcelFile = !!target.files[0].name.match(/(.xls|.xlsx|.csv)/);
    if (!this.isExcelFile) {
      this.uploadFileObject = '';
      this.isExcelFileTrue = false;
      return;
    }

    if (this.isExcelFile) {
      this.uploadFileObject = files.target.files[0];
      this.isExcelFileTrue = true;
    }
  }
  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
